import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { ThemeButton } from '@shared/ui/buttons';
import CardDisplay from '@widgets/cards/CardDisplay';
import { useForm } from 'react-hook-form';
import Note from '@shared/ui/messages/Note';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { icons } from '@shared/static/icons';
import { useTranslation } from 'react-i18next';
import { BasicSelectInput } from '@shared/ui/forms/inputs';
import { fetchAllGroups } from '@app/store/slices/myTeamSlice';
import { useCards } from '@app/api/cards/useCards';
import { validateServerErrors } from '@utils/validation';

export default function ChangeCardOwnerDialog({ close, data }) {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const { allGroups } = useSelector((state) => state.my_team);
  const { changeOwner } = useCards();

  useEffect(() => {
    dispatch(fetchAllGroups());
  }, []);

  const {
    control,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {
      currentOwnerId: data?.owner?.id,
      new_owner: null,
    },
  });

  async function onSubmit(formData) {
    try {
      setIsLoading(true);
      const payload = {
        new_owner: formData.new_owner,
        cards: [data?.id],
      };
      const res = await changeOwner(payload);
      if (res) close();
    } catch (err) {
      console.error(err);
      validateServerErrors(setError, err);
    } finally {
      setIsLoading(false);
    }
  }

  const currentTeamUsers = allGroups
    .find((group) => group.id === data?.group?.id)
    ?.users?.filter((user) => user.id !== data?.owner?.id);

  return (
    <>
      <DialogContent>
        <div className="ownerChange">
          <Note
            title={t('important')}
            content={t('owner_change_note')}
            type="warning"
          />
          <div className="ownerChange__card">
            <CardDisplay data={data} />
          </div>
          <div className="form">
            <div className="form-group-arrow">
              <BasicSelectInput
                control={control}
                name="currentOwnerId"
                label={t('current_owner')}
                disabled
                data={[data?.owner]}
                icon="user-input"
              />
              <div className="arrow-icon">{icons['chevron-right']}</div>
              <BasicSelectInput
                control={control}
                name="new_owner"
                label={t('new_owner')}
                data={currentTeamUsers}
                icon="user-input"
                placeholder={t('Administrator')}
                searchable
                error={errors.new_owner}
              />
            </div>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <ThemeButton
          loading={isLoading}
          minWidth
          startIcon="check"
          block={false}
          onClick={handleSubmit(onSubmit)}
        >
          {t('confirm')}
        </ThemeButton>
      </DialogActions>
    </>
  );
}
